"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function SobreNosotros() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="sobre-nosotros" className="dark bg-background text-foreground relative py-24 px-4 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iZ3JhaW4iIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIxIiBmaWxsPSJyZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDIpIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyYWluKSIvPjwvc3ZnPg==)] opacity-40 pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={imageRef} className={`relative transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <Card className="overflow-hidden border-0 shadow-strong">
              <div className="relative aspect-[4/5] rounded-lg overflow-hidden">
                <img src="https://bodegajulian.es/wp-content/uploads/2026/02/Captura-de-pantalla-2026-02-07-a-las-16.30.11.png" alt="Interior rústico de Bodega Julian" className="w-full h-full object-cover" />
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-dark-background/20" />
              </div>
            </Card>
            {}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary/10 rounded-full blur-3xl pointer-events-none" />
          </div>

          {}
          <div ref={textRef} className={`space-y-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-200 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <h2 className="font-display text-4xl md:text-5xl text-foreground tracking-tight">
                Sobre Nosotros
              </h2>
              <div className="w-20 h-1 bg-primary rounded-full" />
            </div>

            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed">
              <p className="animate-reveal">En el corazón del Puerto de la Cruz, en la calle Mequinez 20, se encuentra el mejor restaurante&nbsp;<span className="text-primary font-semibold" data-ast-id="f:/src/pages/Home/sections/SobreNosotros.tsx|sig:od6244" data-ast-start="2839" data-ast-end="2904">Bodega Julian</span>, un rincón donde la tradición española cobra vida con cada bocado.</p>

              <p className="animate-reveal delay-100">
                Nuestra cocina casera, elaborada con <span className="text-foreground">alma y
                corazón</span>, utiliza únicamente los mejores ingredientes de productores
                locales. Cada plato cuenta una historia, cada vino tiene su
                leyenda, y cada visita se convierte en un recuerdo imborrable.
              </p>

              <p className="animate-reveal delay-200">
                Aquí, los sabores canario-españoles se entrelazan en un ambiente
                acogedor que invita a quedarse, a disfrutar y, sobre todo, a
                volver. La autenticidad es nuestra firma, y la calidad nuestra
                promesa.
              </p>

              <p className="animate-reveal delay-300 text-foreground font-semibold italic">
                "Tradición en cada bocado, historia en cada copa."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}